<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Librairie" />
            <Librairie />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import Librairie from '../Librairie/Librairie.vue'

export default {
    name: 'LibrairiePage',
    components: {
        NavBar,
        PageTitle,
        Librairie,
        FooterComp,
    }
}
</script>